import * as t from 'io-ts';
import { SocialStatus, SocialStatusType } from '../../Dictionaries/models/socialStatus';
import UserProfileAddress, { UserProfileAddressType } from './userProfileAddress';
import UserProfileContacts, { UserProfileContactsType } from './userProfileContacts';
import UserProfileDate, { UserProfileDateType } from './userProfileDate';
import UserProfilePersonality, { UserProfilePersonalityType } from './userProfilePersonality';

export const UserProfileType = t.interface({
    id: t.string,
    post: t.union([t.string, t.null, t.undefined]),
    userId: t.union([t.string, t.null, t.undefined]),
    comment: t.union([t.string, t.null, t.undefined]),
    gtoNumber: t.union([t.string, t.null, t.undefined]),
    address: t.union([UserProfileAddressType, t.null]),
    updateDate: t.union([t.string, t.null, t.undefined]),
    contacts: t.union([UserProfileContactsType, t.null]),
    personality: t.union([UserProfilePersonalityType, t.null]),
    receiveSystemMessages: t.union([t.boolean, t.null, t.undefined]),
    interests: t.union([t.array(UserProfileDateType), t.null, t.undefined]),
    professions: t.union([t.array(UserProfileDateType), t.null, t.undefined]),
    socialStatuses: t.union([t.array(SocialStatusType), t.null, t.undefined]),
});

export interface UserProfileDto extends t.TypeOf<typeof UserProfileType> {
}

class UserProfile {
    id: string;
    post: string | null;
    userId: string | null;
    comment: string | null;
    gtoNumber: string | null;
    updateDate: string | null;
    receiveSystemMessages: boolean;
    address: UserProfileAddress | null;
    interests: UserProfileDate[] | null;
    contacts: UserProfileContacts | null;
    professions: UserProfileDate[] | null;
    socialStatuses: SocialStatus[] | null;
    personality: UserProfilePersonality | null;

    constructor(params: UserProfileDto) {
        this.id  = params.id;
        this.post = params.post ?? null;
        this.userId = params.userId ?? null;
        this.comment = params.comment ?? null;
        this.gtoNumber = params.gtoNumber ?? null;
        this.updateDate = params.updateDate ?? null;
        this.address = !!params.address
            ? new UserProfileAddress(params.address)
            : null;
        this.contacts = !!params.contacts
            ? new UserProfileContacts(params.contacts)
            : null;
        this.personality = !!params.personality
            ? new UserProfilePersonality(params.personality)
            : null;
        this.receiveSystemMessages = !!params.receiveSystemMessages;
        this.interests = !!params.interests
            ? params.interests.map(interest => new UserProfileDate(interest))
            : [];
        this.professions = !!params.professions
            ? params.professions.map(profession => new UserProfileDate(profession))
            : [];
        this.socialStatuses = !!params.socialStatuses
            ? params.socialStatuses.map(socialStatus => new SocialStatus(socialStatus))
            : [];
    }
}

export default UserProfile;
